import {Component, OnDestroy, OnInit} from '@angular/core';
import {AsyncPipe} from '@angular/common';
import {SharedModule} from '../../shared/shared.module';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {SupervisorService} from '../../core/services/supervisor.service';
import {StbChannelService} from '../../core/services/stb-channel.service';
import {Store} from '@ngrx/store';
import {MessagesState} from '../../state/messages.reducer';
import {find, Observable, Subscription} from 'rxjs';
import {MessageRecipient} from '../../core/models/message-recipient.model';
import {selectMessageRecipientById} from '../../state/messages.selectors';
import {getMessageRecipient} from '../../state/messages.actions';

@Component({
  selector: 'cm-smart-app-message-viewer',
  imports: [
    AsyncPipe,
    SharedModule
  ],
  templateUrl: './smart-app-message-viewer.component.html',
  styleUrl: './smart-app-message-viewer.component.scss',
})
export class SmartAppMessageViewerComponent implements OnInit, OnDestroy {
  private messageRecpientRevokedSubscription: Subscription;

  messageRecipientId: number;
  messageRecipient$: Observable<MessageRecipient>;
  currentMessage: number = 1;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly supervisor: SupervisorService,
    private readonly stbChannel: StbChannelService,
    private readonly store$: Store<MessagesState>
  ) {}

  ngOnInit(): void {
    this.route.params.forEach((params: Params) => {
      this.messageRecipientId = +params['messageRecipientId'];
    });

    this.messageRecipient$ = this.store$.select(
      selectMessageRecipientById(this.messageRecipientId)
    );

    this.messageRecpientRevokedSubscription =
      this.stbChannel.messageRecipientRevoked$.subscribe((data: any) => {
        this.revokeMessageRecipient(data);
      });
  }

  ngOnDestroy(): void {
    this.messageRecpientRevokedSubscription.unsubscribe();
  }

  revokeMessageRecipient(data) {
    // if (this.messageRecipient.id === data.messageRecipientId) {
    //   this.router.navigate(['supervisor/listener']);
    // }
  }

  onCurrentMessageChanged(messageIndex) {
    this.currentMessage = messageIndex + 1;
  }
}



